import { Spinner } from "@/shared-web.ui/ui.spinner";

import { useCartContext } from "./cart.context";

const CartOverlay = () => {
  const {
    cartState: {
      isSubmitting,
    },
  } = useCartContext();

  if (!isSubmitting) {
    return null;
  }

  return (
    <div className={`
      absolute inset-0 z-50 flex items-center justify-center
      bg-overlay opacity-40
    `}
    >
      <Spinner size="3" />
    </div>
  );
};

export { CartOverlay };
